import { format } from 'date-fns';

export const DATE_FORMAT = 'yyyy-MM-dd';

export const DATE_TIME_FORMAT = "yyyy-MM-dd'T'HH:mm:ss";

export const formatDateTimeServer = (serverDate: any) => {
  if (!(serverDate instanceof Date)) {
    return '';
  }
  return format(serverDate, DATE_TIME_FORMAT);
};
